<template>
  <li class="p-lifestage">
    <input
      type="radio"
      name="lifestage"
      :id="'l' + lifestage.VALUE"
      class="c-lifestage"
      :value="lifestage.LABEL"
      v-model="radioLifestage"
    />
    <label :for="'l' + lifestage.VALUE" class="c-lifestage--label">
      <img :src="require(`@/assets/img/${lifestage.IMG}`)" />
      <p>{{ lifestage.LABEL }}</p>
    </label>
  </li>
</template>

<script>
import { LIFESTAGE_LABELS } from "@/const.js";
import { mapGetters } from "vuex";

export default {
  name: "LifestageForm",
  beforeMount() {
    this.validating();
    this.$emit("update-condition", this.validated);
  },
  props: {
    lifestage: Object,
  },
  data() {
    return {
      validated: false,
    };
  },
  computed: {
    ...mapGetters(["getLifestage"]),
    lifestages() {
      return LIFESTAGE_LABELS;
    },
    radioLifestage: {
      get() {
        return this.getLifestage;
      },
      set(value) {
        this.$store.commit("updateLifestage", { value });
        this.$store.commit("setRecommend", { value });
        this.validating();
        this.$emit("update-condition", this.validated);
      },
    },
  },
  methods: {
    validating() {
      this.validated = !!this.radioLifestage;
    },
  },
};
</script>

<style scoped lang="scss">
.p-lifestage {
  @include sp {
    width: 48%;
    margin-bottom: 8px;
  }
}
</style>